module.exports = __webpack_public_path__ + "static/media/image_b2b_bg.810f35cd.png";